/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext } from 'react';
import moment from 'moment';

import { AuthContext } from '../../contexts/AuthContext';

const AdminTopbar = props => {

    const { maintenance } = useContext(AuthContext);

    const toggleSidebar = e => {
        e.preventDefault();
        document.getElementById("dashboardContainer").classList.toggle("sb-sidenav-toggled");
    }

    return (
        <nav className="sb-topnav navbar navbar-expand navbar-dark bg-dark">
            <a className="navbar-brand font-weight-bold" href="/admin/dashboard">Umang Wellness</a>
            <button className="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" href="#" onClick={toggleSidebar}>
                <i className="fas fa-bars" style={{ fontSize: "1.5rem", color: "#fff" }}></i>
            </button>
            {maintenance.status ? <div className="marquee" style={{ color: "#fff" }}><div>Umang Wellness is going to conduct maintenace to improve your experience. It will go under maintenance on {moment(maintenance.startAt).format("DD-MM-YYYY [at] hh:mm A")} for {maintenance.duration} minutes. During these time you won't be able to use Umang Wellness.</div></div> : null}
        </nav>
    )


};

export default AdminTopbar;